/* jshint ignore:start */

var MenuManager = (function ($) {
    var instance;

    function init() {

        function iniciandoDropdown() {
            $(document).ready(function () {

                $(".js-megamenu__dropdown").hover(

                    function () {
                    },

                    function () {
                        $('.tabs-menu__nav').removeClass('active');
                        $('.js-tabs-menu__content-element').removeClass('show');
                        $('.js-li-drop').removeClass('show');

                        $('.js-dropdown-tab').data('status', 'close');
                    });

                $(".dropdown-menu__navigation-element .js-with-childs").hover(

                    function () {
                        $(this).children('ul').slideDown('fast');
                        $(this).addClass('selected');
                    },

                    function () {
                        $('ul', this).slideUp('fast');
                        $(this).removeClass('selected');

                        $('.tabs-menu__nav').removeClass('active');
                        $('.js-dropdown-tab').data('status', 'close');
                    });

                // $(".dropdown-menu__navigation-element .js-with-childs").on("click", function() {
                //     var $ele = $(this);                    

                //     if ($ele.hasClass('selected')) {
                //         $('ul', this).slideUp('fast');
                //         $(this).removeClass('selected');

                //         $('.tabs-menu__nav').removeClass('active');
                //         $('.js-dropdown-tab').data('status', 'close');
                //     } else {
                //         $(this).children('ul').slideDown('fast');
                //         $(this).addClass('selected');
                //     }
                // });

                $(".dropdown-menu__navigation-element .js-with-childs2").on("click", function() {
                    var $ele = $(this);                    

                    if ($ele.hasClass('selected')) {
                        $('ul', this).slideUp('fast');
                        $(this).removeClass('selected');

                        $('.tabs-menu__nav').removeClass('active');
                        $('.js-dropdown-tab').data('status', 'close');
                    } else {
                        $(this).children('ul').slideDown('fast');
                        $(".dropdown-menu__navigation-element .js-with-childs2").removeClass('selected');
                        $(this).addClass('selected');
                    }
                });


                $('.tabs-menu__nav .js-dropdown-tab').click(function (e) {
                    e.preventDefault();
                    var status = $(this).data('status');

                    if (status == 'close') {
                        $(this).closest('.tabs-menu__nav').addClass('active');

                        $('.tabs-menu__nav li').removeClass('show');
                        $(this).parent().addClass('show');

                        var currentTab = $(this).attr('href');
                        $('.tabs-menu__content > div').removeClass('show');
                        $(currentTab).addClass('show');

                        $('.js-dropdown-tab').data('status', 'close');
                        $(this).data('status', 'open');
                    } else {
                        $(this).closest('.tabs-menu__nav').removeClass('active');

                        $('.tabs-menu__nav li').removeClass('show');

                        var currentTab = $(this).attr('href');
                        $('.tabs-menu__content > div').addClass('show');
                        $(currentTab).removeClass('show');

                        $(this).data('status', 'close');


                    }
                });


                // LOGO ANIMATION

                $('.megamenu__logo-animation-detail').addClass('open', 1000);


                // STICKY MENU 

                $(window).scroll(function() {    
                    var scroll = $(window).scrollTop();
                
                    if (scroll >= 50) {
                        $(".header").addClass("sticky");
                        $(".megamenu__logo-animation-detail").removeClass("open");
                    } else{
                        $(".header").removeClass("sticky");
                        $(".megamenu__logo-animation-detail").addClass("open");
                    }
                });

                AOS.init({
                    duration: 1200,
                })

            });



            // OLD ANIMATION 1

            /*
            var tl = new TimelineMax({ onUpdate: updatePercentage });
            const controller = new ScrollMagic.Controller();

            tl.to(".scrollmagic__zoom-box1", 1, { width: "100%", height: "700px", borderRadius: "0px" }, 0.3);
            tl.to(".scrollmagic__zoom-box2", 1, { width: "100%", height: "700px", marginBottom: "-1400px", marginLeft: "-180%" }, 0.3);
            tl.to(".scrollmagic__zoom-layer", 1, { opacity: "0" }, 0.3);
            tl.to(".scrollmagic__zoom-box3", 1, { transform: "scale(1)", opacity: "1" });
            //tl.to(".scrollmagic__zoom-time", 1, { width: "100%" });

            const scene = new ScrollMagic.Scene({
                triggerElement: ".sticky", 
                triggerHook: "onLeave",
                duration: "600%"  
            })
 
            .setPin(".sticky")
            .setTween(tl)
            .addTo(controller);          

            function updatePercentage(){
                tl.progress();
            }

            */

            
            // NEW ANIMATION 


            /*
            var tl = new TimelineMax({ onUpdate: updatePercentage });
            const controller = new ScrollMagic.Controller();

            tl.to(".animation-joinup__box-1", 1, { width: "100%", height: "100%"});
            tl.to(".animation-joinup__box-2", 1, { opacity: "1"});

            const scene = new ScrollMagic.Scene({ 
                triggerElement: ".sticky", 
                triggerHook: "onLeave",
                duration: "500%"  
            })
 
            .setPin(".sticky")
            .setTween(tl)
            .addTo(controller);          

            function updatePercentage(){
                tl.progress();
            }
            */

            TweenLite.defaultEase = Linear.easeNone;
            var ctrl = new ScrollMagic.Controller();

            // Create scenes
            $(".animation-joinup").each(function(i) {
                var target1 = $(this).find(".animation-joinup__box-1");
                var tl = new TimelineMax();

                tl.to(target1, 1, { width: "100%", height: "100%"});

                new ScrollMagic.Scene({
                    triggerElement: ".sticky", 
                    triggerHook: "onLeave",
                    duration: "400%"  
                })

                .setPin(".sticky")
                .setTween(tl)
                .addTo(ctrl)
            });

            // Create scenes
            $(".animation-joinup").each(function(i) {
                var target2 = $(this).find(".animation-joinup__box-2");
                var tl = new TimelineMax();

                tl.to(target2, 1, { opacity: "1"}, 4);

                new ScrollMagic.Scene({
                    triggerElement: ".sticky", 
                    triggerHook: "onLeave",
                    duration: "400%"  
                })

                .setTween(tl)
                .addTo(ctrl)
            });
            
        }

        function iniciandoMobileMenu() {
            // Lang selected

            $(".header__mobile-lang ul li a").click(function (e) {
                $('.header__mobile-lang ul li a').removeClass('selected');
                $(this).addClass('selected');
            });

            // OPEN CLOSE MENU

            $(".js-open-menu").click(function (e) {
                $('body').addClass('translate');
                $(window).resize();
            });
            $(".js-close-menu").click(function (e) {
                $('body').removeClass('translate');
            });            
        }

        function openSearch() {
            $('.js-layer-search').addClass('show');
        }

        function hideSearch() {
            $('.js-layer-search').removeClass('show');
        }

        return {
            initMobile: function () {
                iniciandoMobileMenu();
            },

            initDesktop: function () {
                iniciandoDropdown();
            },

            initCommon: function () {
                $('.js-no-click').on("click", function (e) {
                    e.preventDefault();
                });

                $('.js-search-open').on("click", function (e) {
                    e.preventDefault();

                    openSearch();
                });

                $('.js-close-search').on("click", function (e) {
                    e.preventDefault();

                    hideSearch();
                });


            },


            init: function () {
                this.initMobile();
                this.initDesktop();
                this.initCommon();
            }
        };
    }


    return {

        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
